import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/CreateReport.api';

export const getQueryRequest = () => ({
    type: actionTypes.GET_QUERY_REPORT_HEADERS_REQUEST,
  });

  export const getQuerySuccess = (data) => ({
    type: actionTypes.GET_QUERY_REPORT_HEADERS_SUCCESS,
    payload: data,
  });

  export const getQueryFailure = (error) => ({
    type: actionTypes.GET_QUERY_REPORT_HEADERS_FAILURE,
    payload: error,
  });


  export const getQuery = (data) => {

    return async (dispatch) => {
      dispatch(getQueryRequest(data));
      try {
        const getData = await api.fetchQueryData(data);
        dispatch(getQuerySuccess(getData));
        return { success: true, data: getData };
      } catch (error) {
        dispatch(getQueryFailure(error));
        return { success: false, message: error };
      }
    };
  };



export const CreateReportAndReportColumnRequest = (reportData) => ({
  type: actionTypes.CREATE_REPORT_HEADERS_REQUEST,
  payload: reportData,
});

export const CreateReportAndReportColumnSuccess = (message) => ({
  type: actionTypes.CREATE_REPORT_HEADERS_SUCCESS,
  payload: message,
});

export const CreateReportAndReportColumnFailure = (error) => ({
  type: actionTypes.CREATE_REPORT_HEADERS_FAILURE,
  payload: error,
});

export const createReportAndReportColumn = (reporData) => {
  return async (dispatch) => {
    dispatch(CreateReportAndReportColumnRequest(reporData));
    try {
      const response = await api.createReportAndReportColumn(reporData);
      dispatch(CreateReportAndReportColumnSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(CreateReportAndReportColumnFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getReportAndReportColumnRequest = () => ({
  type: actionTypes.GET_REPORT_HEADERS_REQUEST,
});

export const getReportAndReportColumnSuccess = (reporData) => ({
  type: actionTypes.GET_REPORT_HEADERS_SUCCESS,
  payload: reporData,
});

export const getReportAndReportColumnFailure = (error) => ({
  type: actionTypes.GET_REPORT_HEADERS_FAILURE,
  payload: error,
});

export const getReportAndReportColumn = () => {
  return async (dispatch) => {
    dispatch(getReportAndReportColumnRequest());
    try {
      const reportdata = await api.fetchReportAndReportColumn();
      dispatch(getReportAndReportColumnSuccess(reportdata));
      return { success: true, data: reportdata };
    } catch (error) {
      dispatch(getReportAndReportColumnFailure(error));
      return { success: false, message: error };
    }
  };
};



export const updateReportAndReportColumnRequest = (reportcode, reportData) => ({
  type: actionTypes.UPDATE_REPORT_HEADERS_REQUEST,
  payload: { reportcode, reportData },
});

export const updateReportAndReportColumnSuccess = (message) => ({
  type: actionTypes.UPDATE_REPORT_HEADERS_SUCCESS,
  payload: message,
});

export const updateReportAndReportColumnFailure = (error) => ({
  type: actionTypes.UPDATE_REPORT_HEADERS_FAILURE,
  payload: error,
});

export const updateReportAndReportColumnById = (reportcode, reportData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    reportData.updated_by = user.user_name;

    dispatch(updateReportAndReportColumnRequest(reportcode, reportData));
    try {
      const response = await api.updateReportAndReportColumn(reportcode, reportData);
      dispatch(updateReportAndReportColumnSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateReportAndReportColumnFailure(error));
      return { success: false, message: error };
    }
  };
};


export const deleteReportAndReportColumnRequest = (reportcode) => ({
  type: actionTypes.DELETE_REPORT_HEADERS_REQUEST,
  payload: reportcode,
});

export const deleteReportAndReportColumnSuccess = (message) => ({
  type: actionTypes.DELETE_REPORT_HEADERS_SUCCESS,
  payload: message,
});

export const deleteReportAndReportColumnFailure = (error) => ({
  type: actionTypes.DELETE_REPORT_HEADERS_FAILURE,
  payload: error,
});

export const deleteReportAndReportColumnByreportcode = (reportcode) => {
  return async (dispatch) => {
    dispatch(deleteReportAndReportColumnRequest(reportcode));
    try {
      const response = await api.deleteReportAndReportColumn(reportcode);
      dispatch(deleteReportAndReportColumnSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteReportAndReportColumnFailure(error));
      return { success: false, message: error };
    }
  };
};

